import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, ArrowRight, Download } from "lucide-react";
import NagoLogo from "@/components/NagoLogo";
import { COMPANY_PROFILE_PDF } from "@/components/DownloadProfileButton";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/brands", label: "Brands" },
  { to: "/clients", label: "Clients" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur border-b border-slate-200"
      data-testid="site-navbar"
    >
      <div className="container-nago flex items-center justify-between h-24">
        <Link to="/" className="flex items-center gap-3 py-1" data-testid="nav-logo">
          <NagoLogo className="h-14 sm:h-16 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              data-testid={`nav-link-${item.label.toLowerCase()}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={COMPANY_PROFILE_PDF}
            download="Nago-International-Company-Profile.pdf"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-slate-700 hover:text-[#E30613] font-medium text-sm px-3 py-2 rounded-lg hover:bg-slate-50 transition-all duration-200"
            data-testid="nav-download-profile-btn"
            title="Download Nago International Company Profile PDF"
          >
            <Download className="w-4 h-4" />
            Profile PDF
          </a>
          <Link
            to="/contact"
            className="btn-primary text-sm px-5 py-2.5"
            data-testid="nav-quote-btn"
          >
            Request a Quote <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <button
          type="button"
          className="lg:hidden inline-flex items-center justify-center w-11 h-11 border border-slate-300 rounded-xl text-slate-700"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white" data-testid="mobile-menu">
          <div className="container-nago py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `block px-3 py-3 border-l-2 ${
                    isActive
                      ? "border-[#E30613] text-[#1E3A8A] font-semibold bg-slate-50"
                      : "border-transparent text-slate-700"
                  }`
                }
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="btn-primary mt-3"
              data-testid="mobile-quote-btn"
            >
              Request a Quote <ArrowRight className="w-4 h-4" />
            </Link>
            <a
              href={COMPANY_PROFILE_PDF}
              download="Nago-International-Company-Profile.pdf"
              target="_blank"
              rel="noreferrer"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 border border-slate-300 text-slate-700 font-semibold px-6 py-3 rounded-lg hover:border-[#1E3A8A] hover:text-[#1E3A8A] transition-colors"
              data-testid="mobile-download-profile-btn"
            >
              <Download className="w-4 h-4" />
              Download Company Profile
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
